import { LS_WIDGET_STATE_KEY } from '../constants';

const getLsWidgetState = (vehicleId = null, initialSteps = {}) => {
	if (window) {
		let lsWidgetState =
			JSON.parse(localStorage.getItem(LS_WIDGET_STATE_KEY)) || {};

		if (!lsWidgetState[vehicleId]) {
			lsWidgetState = { ...lsWidgetState, [vehicleId]: initialSteps };
		}

		return lsWidgetState;
	}
	return null;
};

export const getLsWidgetStateByVehicleId = (
	vehicleId = null,
	initialSteps = {}
) => {
	const lsWidgetState = getLsWidgetState(vehicleId, initialSteps);
	return lsWidgetState?.[vehicleId];
};

export const updateLsWidgetState = (vehicleId = null, steps = {}) => {
	if (window) {
		const lsWidgetState = getLsWidgetState(vehicleId, steps);
		const newWidgetState = {
			...lsWidgetState,
			[vehicleId]: {
				...steps
			}
		};
		localStorage.setItem(
			LS_WIDGET_STATE_KEY,
			JSON.stringify(newWidgetState)
		);
	}
};
